import { render } from "./Tabs.vue?vue&type=template&id=20043256&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=20043256&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20043256"

export default script